import { ApolloClient, ApolloQueryResult } from "@apollo/client";
import { GetPositionDetailsDocument } from "#graphql/supergraphHooks";
import { type GetPositionDetailsQuery } from "#graphql/supergraphTypes";
import { clientContext } from "#utils/graphql_utils";
import { PositionRowItem } from "./types";
import { positionsTableUtils } from "./utils/positionsGQLUtils";
import { PositionProps } from "./index";

/**
 * This is the data source for the Positions table.
 */
export class PositionsGqlDataSource {
  private apiClient: ApolloClient<object>;
  private props: PositionProps;

  constructor(client: ApolloClient<object>, props: PositionProps) {
    this.apiClient = client;
    this.props = props;
  }

  async getPositionData(): Promise<PositionRowItem[]> {
    const positionDetails: ApolloQueryResult<GetPositionDetailsQuery> =
      await this.apiClient.query<GetPositionDetailsQuery>({
        query: GetPositionDetailsDocument,
        context: clientContext(),
        variables: {
          paymentBatchId: this.props.id,
        },
        fetchPolicy: "no-cache",
      });
    return positionsTableUtils.prepareDisplayItem(positionDetails, this.props);
  }
}
